import { defineSlotRecipe } from '@chakra-ui/react';
import { listAnatomy } from '@chakra-ui/react/anatomy';

export default defineSlotRecipe({
  slots: listAnatomy.keys(),
  variants: {
    variant: {
      marker: {
        root: {
          marginInlineStart: '1em',
        },
        item: {
          _marker: {
            color: 'fg.solid',
          },
        },
      },
    },
  },
});
